import { useTranslation } from "react-i18next";

const FormLabel = ({
  as: Component = "label",
  htmlFor,
  id,
  children,
  required,
  hint,
  action,
}) => {
  const { t } = useTranslation();

  let content;

  switch (Component) {
    case "legend":
      content = (
        <legend className="block text-sm font-medium leading-5 text-gray-700">
          {children}
          {required && <span className="text-red-500 ml-1">*</span>}
        </legend>
      );
      break;

    case "div":
      content = (
        <div className="block text-sm font-medium leading-5 text-gray-700">
          {children}
          {required && <span className="text-red-500 ml-1">*</span>}
        </div>
      );
      break;

    default:
      content = (
        <label
          id={id}
          htmlFor={htmlFor}
          className="block text-sm font-medium leading-5 text-gray-700"
        >
          {children}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      );
  }

  // A trailing control belongs in this row rather than in a header the field
  // builds for itself, because the row is what sets how far the input sits
  // below the top of its grid cell. A field that rolls its own label row drifts
  // out of line with the field beside it the moment the two rows differ in
  // height by a pixel.
  return (
    <div className="flex flex-wrap items-center justify-between gap-x-2 mb-1">
      {content}
      {Boolean(hint) && (
        <span id={`${htmlFor}-hint`} className="text-sm text-gray-500">
          {t(hint)}
        </span>
      )}
      {action}
    </div>
  );
};

export default FormLabel;
